<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>Condições Habitacionais</b></h5>
        </th>
      </tr>
      <tr>
        <td>
          CARACTERÍSTICAS DO LOCAL ONDE ESTÁ SITUADO O DOMICÍLIO:
          <b v-html="formatResultArray(item.domicilio.local, $root.arrays.local)"></b>
        </td>
        <td>
          TIPO DE RESIDÊNCIA:
          <b
            v-html="
              formatResultArray(
                item.domicilio.tipo_residencia,
                $root.arrays.tipo_residencia
              )
            "
          ></b>
        </td>
      </tr>
      <tr>
        <td>
          QUANTOS CÔMODOS TEM SEU DOMICÍLIO?
          <b>{{ item.domicilio.quant_comodos }}</b>
        </td>
        <td>
          QUAL O Nº DE CÔMODOS UTILIZADOS COMO DORMITÓRIO?
          <b>{{ item.domicilio.quant_comodos_dormitorio }}</b>
        </td>
      </tr>
      <tr>
        <td>
          QUANTO É Nº DE PESSOAS DO DOMICÍLIO DIVIDIDO PELO Nº DE DORMITÓRIOS?
          <b>{{ item.domicilio.numero_pessoas_dormitorio }}</b>
        </td>
        <td>
          MATERIAL PREDOMINANTE NO PISO?
          <b
            v-html="
              formatResultArray(item.domicilio.material_piso, $root.arrays.material_piso)
            "
          ></b>
        </td>
      </tr>
      <tr>
        <td>
          MATERIAL PREDOMINANTE NA CONSTRUÇÃO DAS PAREDES EXTERNAS?
          <b
            v-html="
              formatResultArray(
                item.domicilio.material_paredes,
                $root.arrays.material_paredes
              )
            "
          ></b>
        </td>
        <td>
          POSSUI ÁGUA CANALIZADA PARA, PELO MENOS, UM CÔMODO?
          <b
            v-html="
              formatResultArray(item.domicilio.agua_canalizada, $root.arrays.pergunta)
            "
          ></b>
        </td>
      </tr>
      <tr>
        <td>
          FORMA DE ABASTECIMENTO DE ÁGUA UTILIZADA NO SEU DOMICÍLIO?
          <b
            v-html="
              formatResultArray(
                item.domicilio.forma_abastecimento_agua,
                $root.arrays.forma_abastecimento_agua
              )
            "
          ></b>
        </td>
        <td>
          NA PROPRIEDADE EXISTE BANHEIRO OU SANITÁRIO?
          <b
            v-html="formatResultArray(item.domicilio.banheiro, $root.arrays.pergunta)"
          ></b>
        </td>
      </tr>
      <tr>
        <td>
          DE QUE FORMA É FEITO O ESCOAMENTO DO BANHEIRO OU SANITÁRIO?
          <b
            v-html="
              formatResultArray(
                item.domicilio.forma_escoamento_sanitario,
                $root.arrays.forma_escoamento_sanitario
              )
            "
          ></b>
        </td>
        <td>
          FORMA DE COLETA DO LIXO?
          <b
            v-html="
              formatResultArray(item.domicilio.destino_lixo, $root.arrays.destino_lixo)
            "
          ></b>
        </td>
      </tr>
      <tr>
        <td>
          FORMA DE ILUMINAÇÃO UTILIZADA NO SEU DOMICÍLIO?
          <b
            v-html="formatResultArray(item.domicilio.iluminacao, $root.arrays.iluminacao)"
          ></b>
        </td>
        <td>
          EXISTE CALÇAMENTO/PAVIMENTAÇÃO EM FRENTE AO SEU DOMICÍLIO?
          <b
            v-html="
              formatResultArray(
                item.domicilio.calcamento_pavimentacao,
                $root.arrays.calcamento_pavimentacao
              )
            "
          ></b>
        </td>
      </tr>
      <tr>
        <td>
          POSSUI ACESSIBILIDADE PARA PESSOAS COM DIFICULDADE DE LOCOMOÇÃO?
          <b
            v-html="
              formatResultArray(
                item.domicilio.acessibilidade_locomocao,
                $root.arrays.pergunta
              )
            "
          ></b>
        </td>
        <td>
          DOMICÍLIO LOCALIZADO EM ÁREA DE RISCO DE DESABAMENTO OU ALAGAMENTO?
          <b
            v-html="formatResultArray(item.domicilio.area_risco, $root.arrays.pergunta)"
          ></b>
        </td>
      </tr>
      <tr>
        <td>
          DOMICÍLIO LOCALIZADO EM ÁREA DE DIFÍCIL ACESSO GEOGRÁFICO
          <b
            v-html="
              formatResultArray(item.domicilio.area_dificl_acesso, $root.arrays.pergunta)
            "
          ></b>
        </td>
        <td>
          DOMICÍLIO LOCALIZADO EM ÁREA COM FORTE PRESENÇA DE CONFLITO/VIOLÊNCIA?
          <b
            v-html="formatResultArray(item.domicilio.area_risco, $root.arrays.pergunta)"
          ></b>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          OUTRAS OBSERVAÇÕES REFERENTES AO DIAGNÓSTICO DAS CONDIÇÕES HABITACIONAIS DA
          FAMÍLIA
          <div class="d-block" v-html="item.domicilio.observacoes_domicilio"></div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item"],
  methods: {
    formatResultArray(campo, array) {
      return array.filter((e) => e.id == campo)[0]["value"];
    },
  },
};
</script>

<style lang="scss" scoped></style>
